import { transparentize } from 'polished'
import styled from 'styled-components'

export const CatalogItemImageWrapperStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: ${(props) => props.theme.typography.pxToRem(96)};
  height: ${(props) => props.theme.typography.pxToRem(96)};
  border-radius: ${(props) => props.theme.typography.pxToRem(5)};
  background: ${(props) => transparentize(0.97, props.theme.colors.darkGreen)};
  overflow: hidden;
`
